import template from "./daily_balance_sheet.html";
import controller from "./daily_balance_sheet.controller";
import "./daily_balance_sheet.scss";

let branchMgmtDailyBalanceSheetComponent = {
  restrict: "E",
  bindings: {},
  template,
  controller
};

export default branchMgmtDailyBalanceSheetComponent;


// WEBPACK FOOTER //
// ./client/app/components/branch_management/components/daily_balance_sheet/daily_balance_sheet.component.js